import config from '../../../config/config';
import DefaultApiLimit from '../../../config/defaultLimit';
import { AddFacilityTag } from '../../../interface/partner-interfaces/facility-tag.interface';
import deleteRequest from '../base/delete';
import getRequest from '../base/get';
import patchRequest from '../base/patch';
import postRequest from '../base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Add facility tag API
   * @param {any} data Facility tag data
   */
  addFacilityTag: (data: AddFacilityTag): Promise<any> => {
    return postRequest(`${config.commonApiUrl}api/partner/v1/facility-tag`, data);
  },
  /**
   * Fetch all the facility tags function
   * @returns {any} List of all facility tags
   */
  fetchFacilityTagsList: () => {
    return getRequest(`${config.commonApiUrl}api/partner/v1/facility-tag/list`);
  },
  /**
   * Fetch current facility tags function
   * @returns {any} List of current facility tags
   */
  fetchCurrentFacilityTagsList: () => {
    return getRequest(`${config.commonApiUrl}api/partner/v1/facility-tag`);
  },
  /**
   * Fetch facility tags API
   * @param {any} query Query parameters
   */
  fetchFacilityTags: (query: QueryParameters = {}) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(`${config.commonApiUrl}api/partner/v1/facility-tag`, {
      ...parameters,
    });
  },

  /**
   * Update the facility tag api call function
   * @param {any} id Facility tag id
   * @param {any} data Facility tag data
   * @returns {any} Update result
   */
  editFacilityTag: (id: string, data: any): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(`${config.commonApiUrl}api/partner/v1/facility-tag/${id}`, {
      ...parameters,
    });
  },

  /**
   * Delete facility tag API
   * @param {any} id Facility tag id
   * @returns {any} Delete result
   */
  deleteFacilityTag: (id: string): Promise<any> => {
    return deleteRequest(`${config.commonApiUrl}api/partner/v1/facility-tag/${id}`);
  },

  /**
   * Fetch facility API
   * @returns {any} Facility list filters
   */
  fetchListFilters: () => {
    return getRequest(`${config.commonApiUrl}api/partner/v1/facility-tag/list-filters`);
  },
};
